class StickyHeader {
    constructor(domNode) {
        this.documentElm = document.documentElement;
        this.window = window;
        this.prevScroll = this.window.scrollY || this.documentElm.scrollTop;
        this.currentScroll;
        this.headerHeight;
        this.direction = 0;
        this.prevDirection = 0;
        this.stickyHeader = domNode
        this.stickyOffset = domNode.offsetTop;
        this.header;
        this.masthead = document.querySelector('#masthead');

        // debounce setup
        this.scrollTimeout = null;
        this.scrollDelay = 10;
        this.scrollDelta = 5;

        // bind methods
        this.checkOffset = this.checkOffset.bind(this);
        this.checkScroll = this.checkScroll.bind(this);
        this.setMargin = this.setMargin.bind(this);

        window.addEventListener('scroll', () => {
            if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
            this.scrollTimeout = setTimeout(() => {
                this.checkOffset();
                this.checkScroll();
                this.setMargin();
            }, this.scrollDelay);
        });

        document.addEventListener('DOMContentLoaded', this.setMargin);
        window.addEventListener('resize', this.setMargin);

        this.setMasthead = this.setMasthead.bind(this);
        document.addEventListener('DOMContentLoaded', this.setMasthead);
        window.addEventListener('resize', this.setMasthead);
    }

    checkOffset() {
        const headerElm = this.stickyHeader;
        const stickyOffset = this.stickyOffset;
        const pageOffset = window.scrollY;

        if (pageOffset > stickyOffset) {
            headerElm.classList.add("sticky");
        } else {
            headerElm.classList.remove("sticky");
        }
    }

    toggleHeader(direction, currentScroll) {
        const headerElm = this.stickyHeader;

        if (direction === 2 && currentScroll > this.headerHeight) { 
            headerElm.classList.add('hide');
            this.prevDirection = direction;
        }
        else if (direction === 1) {
            headerElm.classList.remove('hide');
            this.prevDirection = direction;
        }
    }

    checkScroll() {
        let currentScroll = this.window.scrollY || this.documentElm.scrollTop;

        // only trigger if moved more than threshold
        if (Math.abs(currentScroll - this.prevScroll) < this.scrollDelta) return;

        let direction = this.direction;
        let prevScroll = this.prevScroll;
        let prevDirection = this.prevDirection;

        if (currentScroll > prevScroll) { // Scrolling down
            direction = 2;
        }
        else if (currentScroll < prevScroll) { // Scrolling up
            direction = 1;
        }

        if (direction !== prevDirection) {
            this.toggleHeader(direction, currentScroll);
        }

        this.prevScroll = currentScroll;
    }

    setMargin() {
        let headerHeight = this.stickyHeader.offsetHeight;
        if(headerHeight < 35) return;
        if (headerHeight === this.headerHeight) return;
        this.documentElm.style.setProperty('--masthead-height', headerHeight + 'px');
        this.headerHeight = headerHeight;
    }

    setMasthead(){
        let mastheadHeight =this.masthead.offsetHeight;
        this.documentElm.style.setProperty('--header-height', mastheadHeight + 'px');
    }
}

exports.StickyHeader = StickyHeader;